import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { createListenerEffect } from '@socialive/common';
import { setAccountInfo, setCurrentAccountId } from '~/store/accountInfo';
import { resetStreamsData } from '~/store/recordings';

export const effect = createListenerEffect(
  'recordings/resetStreamsData<Listener>',
  async (_, { dispatch, trigger }) => {
    await dispatch(resetStreamsData({ trigger }));
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  matcher: isAnyOf(setCurrentAccountId, setAccountInfo),
  effect,
});

export default middleware;
